// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BnpJI","buttonsWrapper":"styles_buttonsWrapper__yMiCY","logoWrapper":"styles_logoWrapper__bZa2X","tabsWrapper":"styles_tabsWrapper__zCHS8"};